import fetchData from 'src/utils/fetchData';

export const getBanksAPI = async () => {
  return fetchData('/ui/front-api/private/banks');
};

export const getOrganizationBanksAPI = async (organizationUeid: string) => {
  return fetchData(`/ui/front-api/private/organizations/${organizationUeid}/banks`);
};

export const postAddBankAPI = async (organizationUeid: string, data: any) => {
  return fetchData(`/ui/front-api/private/organizations/${organizationUeid}/banks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
};

export const deleteBankAPI = async (organizationUeid: string, bankUeid: string) => {
  return fetchData(`/ui/front-api/private/organizations/${organizationUeid}/banks/${bankUeid}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
